import axiosInstance from './axiosInstance';

const sessionService = {
  current: async () => {
    return await axiosInstance.get('/sessions/current');
  },
  login: async (email: string, password: string) => {
    return await axiosInstance.post('/sessions', { email, password });
  },
  logout: async () => {
    return await axiosInstance.delete('/sessions/current');
  },
};

export default sessionService;
